"use client";

import React from "react";

import { createSVGIcon } from "./util";

/**
 * @trackcomponent
 */
export const Referral = createSVGIcon(
  <>
    <path
      d="M11.5508 11.625H18.8189"
      stroke="currentColor"
      strokeLinecap="round"
    />
    <path
      d="M11.5508 16.5742H18.8189"
      stroke="currentColor"
      strokeLinecap="round"
    />
    <path
      d="M11.5508 21.5234H18.8189"
      stroke="currentColor"
      strokeLinecap="round"
    />
    <path
      d="M7.10947 16.0678L1.05273 20.9962V43.8966H39.0083V20.9962L32.8606 15.7539V25.7586"
      stroke="currentColor"
      strokeLinejoin="round"
    />
    <path
      d="M33.0545 5.19531H7.00654V25.8378M13.7242 30.499H26.0627"
      stroke="currentColor"
      strokeLinecap="round"
    />
    <path
      d="M38.8731 21.5703L25.6123 30.9289L39.0084 43.8971"
      stroke="currentColor"
    />
    <path
      d="M1.05314 21.5703L14.4492 30.9289L1.05314 43.8971"
      stroke="currentColor"
    />
    <path
      d="M39.7585 3.51323L26.137 12.1918L23.3521 16.8388L28.7406 16.2783L42.3621 7.59971C44.4079 6.29631 45.8934 4.871 44.8087 3.16813C43.7112 1.44499 41.8043 2.2098 39.7585 3.51323Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <line
      x1="39.6972"
      y1="3.55165"
      x2="42.3008"
      y2="7.63811"
      stroke="currentColor"
    />
    <line
      x1="36.707"
      y1="5.05946"
      x2="39.3106"
      y2="9.14592"
      stroke="currentColor"
    />
  </>,
  "Referral",
  { viewBox: "0 0 47 45", titleAccess: "Referral", fill: "none" }
);
